var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp__screen noselect"},[_c('markdown',{staticClass:"lamp__title",attrs:{"text":_vm.$t('stories_screen_4_text'),"color":'#3a4f41'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }